module.exports = __webpack_public_path__ + "static/03-d7b9d3da77a20ad7ddf6ae682f68cb0e.png";